/**
 * Helper: Format money
 * -----------------------------------------------------------------------------
 * Formats money into store format.
 *
 * @param {Number} value - Value in cents.
 * @param {String} format - Money format.
 * @returns {String}
 *
 */
import { formatMoney } from '@we-make-websites/theme-currency'

export default (value, format = cnvs.store.moneyFormat, removeZeros = false) => {
  return formatMoney(value, format, removeZeros)
}
